import styled from 'styled-components';
import { th } from 'style/theme';
import { sizes } from 'style';
import { motion } from 'framer-motion';
import { H4 } from 'components/Typography';
import Avatar from '../CustomizeAvatar/components/Avatar';

export const HeaderWrapper = styled(motion.div)`
  display: grid;
  grid-template-columns: 78px auto;
  grid-template-rows: 60% 45%;
  grid-template-areas:
    'avatar name'
    'avatar customize';

  @media ${sizes.tabletPortrait} {
    grid-template-columns: 98px auto;
  }
`;

export const AvatarOverlay = styled.div`
  position: absolute;
  display: flex;
  opacity: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: ${th('colors.transparentWhite.7')};
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: ${th('colors.black')};
  font-size: 12px;
  font-weight: 700;
  transition: opacity 0.2s;
  cursor: pointer;
  user-select: none;

  > svg {
    width: 34px;
    margin-bottom: 5px;
  }
`;

export const StyledAvatar = styled(Avatar)`
  top: 8px;
`;

export const AvatarContainer = styled.div`
  grid-area: avatar;
  position: relative;
  background-color: ${({ background }) => background || 'transparent'};
  background-image: url(${({ src }) => src});
  background-size: cover;
  border-radius: 50%;
  width: 78px;
  height: 78px;
  border: 1px solid ${th('colors.turquoise')};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  :hover {
    > ${AvatarOverlay} {
      opacity: 1;
    }
  }

  @media ${sizes.tabletPortrait} {
    width: 98px;
    height: 98px;
  }
`;

export const Name = styled.div`
  grid-area: name;
  display: flex;
  align-items: center;
  margin-left: 13px;
  margin-top: auto;

  > svg {
    font-size: 18px;
    color: ${th('colors.turquoise')};
    cursor: pointer;
    position: relative;
    top: 2px;
    margin-left: 10px;
  }

  > h4 {
    font-size: 18px;
    display: inline;

    @media ${sizes.tabletPortrait} {
      font-size: 25px;
    }
  }

  > div {
    width: auto;
    margin-bottom: 0;

    :first-child {
      margin-right: 20px;
    }
  }
`;

export const Customize = styled.div`
  grid-area: customize;
  margin-left: 13px;
  margin-top: 4px;

  > span {
    cursor: pointer;
    color: ${th('colors.turquoise')};
    font-size: 14px;
    display: inline-flex;
    align-items: center;

    :hover {
      opacity: 0.8;
    }

    > svg {
      width: 16px;
      margin-right: 6px;
      cursor: pointer;

      .st0 {
        fill: ${th('colors.turquoise')};
      }
    }
  }
`;

export const SaveWrapper = styled.div`
  cursor: pointer;
  > svg {
    font-size: 18px;
    color: ${th('colors.turquoise')};
    position: relative;
    top: 2px;
    margin-left: 10px;
  }

  > span {
    font-size: 16px;
    color: ${th('colors.turquoise')};
    user-select: none;
    display: none;
  }

  @media ${sizes.tabletPortrait} {
    > span {
      display: inline-block;
    }

    > svg {
      font-size: 16px;
      margin-right: 4px;
    }
  }
`;

export const NamePlaceholder = styled(H4)`
  color: ${th('colors.turquoise')};
  text-decoration: underline;
  cursor: pointer;
`;
